module.exports = __webpack_public_path__ + "img/dsci0147.e80343d8.jpg";